import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { tradingServices } from '../../services/trading-service'

export const WATCHLIST = [
  { symbol: 'AAPL', name: 'Apple Inc.' },
  { symbol: 'MSFT', name: 'Microsoft Corporation' },
  { symbol: 'GOOGL', name: 'Alphabet Inc.' },
  { symbol: 'AMZN', name: 'Amazon.com, Inc.' },
  { symbol: 'NVDA', name: 'NVIDIA Corporation' },
]

type Quote = { ap?: number; bp?: number }

const usd = (value: number | undefined) =>
  value && value > 0 ? value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '—'

const WatchlistCard = ({
  onPick,
}: {
  onPick: (asset: { symbol: string; name: string }) => void
}) => {
  const [quotes, setQuotes] = useState<Record<string, Quote>>({})
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)

  const load = useCallback(async () => {
    setLoading(true)
    const res = await tradingServices.getQuotes(WATCHLIST.map((w) => w.symbol))
    if (res?.status === 200) {
      setQuotes(res.data?.quotes ?? {})
      setFailed(false)
    } else {
      setFailed(true)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  return (
    <section className='trading-page__card' data-testid='trading-watchlist'>
      <div className='trading-page__card-head'>
        <h2>Watchlist</h2>
        <button
          type='button'
          className='trading-page__link'
          onClick={() => void load()}
          disabled={loading}
        >
          {loading ? 'Refreshing…' : 'Refresh'}
        </button>
      </div>
      {failed ? <p className='trading-page__error'>Quotes are unavailable right now.</p> : null}
      <table className='trading-page__table'>
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Bid</th>
            <th>Ask</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {WATCHLIST.map((item) => {
            const q = quotes[item.symbol]
            return (
              <tr key={item.symbol}>
                <td>
                  <Link to={`/dashboard/trading/${item.symbol}`}>
                    <strong>{item.symbol}</strong>
                  </Link>
                  <div className='trading-page__muted'>{item.name}</div>
                </td>
                <td>{usd(q?.bp)}</td>
                <td>{usd(q?.ap)}</td>
                <td>
                  <button type='button' className='trading-page__link' onClick={() => onPick(item)}>
                    Trade
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </section>
  )
}

export { WatchlistCard }
